import { Component } from '@angular/core';
import { CoreIcon, ICON_TEMPLATE } from '@primeicons/angular/core';
import { angleDown } from '@primeicons/core/angle-down';

@Component({
    selector: 'svg[data-p-icon="angle-down"]',
    standalone: true,
    template: ICON_TEMPLATE
})
export class AngleDown extends CoreIcon {
    constructor() {
        super();
        this._icon = angleDown;
    }
}
